export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export function isNotEmpty(obj: unknown) {
    return obj !== undefined && obj !== null && obj !== ''
}